import React from 'react';
import { BaasicSelect } from 'core/components';

function BaasicPageSizeSelect({ queryUtility, ...other }) {
	return <BaasicSelect {...other} onChange={selectedOption => queryUtility.changePageSize(selectedOption.value)} />;
}

export default BaasicPageSizeSelect;



// WEBPACK FOOTER //
// ./src/themes/default/components/select/BaasicPageSizeSelectTemplate.jsx